/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询我的观演人列表
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<member.CommonlyDTO>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/viewers`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
